/**
 * Official Spanish translations for Pokémon Abilities (WikiDex/Official Game Localization)
 * Mapping: PokeAPI slug -> Spanish Name
 */
export const ABILITIES_ES = {
  // A
  'adaptability': 'Adaptabilidad',
  'aerilate': 'Piel Celeste',
  'aftermath': 'Resquicio',
  'air-lock': 'Bucle Aire',
  'analytic': 'Analítico',
  'anger-point': 'Irascible',
  'anger-shell': 'Coraza Ira',
  'anticipation': 'Anticipación',
  'arena-trap': 'Trampa Arena',
  'armor-tail': 'Cola Armadura',
  'aroma-veil': 'Velo Aroma',
  'as-one-glastrier': 'Unidad (Glastrier)',
  'as-one-spectrier': 'Unidad (Spectrier)',
  'aura-break': 'Rompeaura',
  'bad-dreams': 'Mal Sueño',
  'ball-fetch': 'Recogebolas',
  'battery': 'Batería',
  'battle-armor': 'Armadura Batalla',
  'battle-bond': 'Fuerte Afecto',
  'beads-of-ruin': 'Abalorio Debilidad',
  'beast-boost': 'Ultraimpulso',
  'berserk': 'Cólera',
  'big-pecks': 'Sacapecho',
  'blaze': 'Mar Llamas',
  'bulletproof': 'Antibalas',
  // C
  'cheek-pouch': 'Carrillo',
  'chlorophyll': 'Clorofila',
  'clear-body': 'Cuerpo Puro',
  'cloud-nine': 'Aclimatación',
  'color-change': 'Cambio Color',
  'comatose': 'Comatoso',
  'commander': 'Comandante',
  'competitive': 'Tenacidad',
  'compound-eyes': 'Ojo Compuesto',
  'contrary': 'Respondón',
  'corrosion': 'Corrosión',
  'costar': 'Unísono',
  'cotton-down': 'Pelusa',
  'cud-chew': 'Rumia',
  'curious-medicine': 'Medicina Extraña',
  'cursed-body': 'Cuerpo Maldito',
  'cute-char': 'Gran Encanto',
  // D
  'damp': 'Humedad',
  'dancer': 'Pareja de Baile',
  'dark-aura': 'Aura Oscura',
  'dauntless-shield': 'Escudo Recio',
  'dazzling': 'Cuerpo Vívido',
  'defeatist': 'Flaqueza',
  'defiant': 'Competitivo',
  'delta-stream': 'Ráfaga Delta',
  'desolate-land': 'Tierra del Fin',
  'disguise': 'Disfraz',
  'download': 'Descarga',
  'dragonize': 'Piel Dragón', // Pokémon Champions (Mega-Feraligatr)
  'dragons-maw': 'Mandíbula Dragón',
  'drizzle': 'Llovizna',
  'drought': 'Sequía',
  'dry-skin': 'Piel Seca',
  // E
  'early-bird': 'Madrugar',
  'earth-eater': 'Terrófago',
  'eelevate': 'Anguilevitación', // Pokémon Champions (Mega-Eelektross)
  'effect-spore': 'Efecto Espora',
  'electric-surge': 'Electrogénesis',
  'electromorphosis': 'Dinamo-morfosis',
  'emergency-exit': 'Retirada',
  'enamored': 'Enamorado',
  'evaporate': 'Evaporación',
  // F
  'fairy-aura': 'Aura Hada',
  'filter': 'Filtro',
  'fire-mane': 'Melena Ígnea', // Pokémon Champions (Mega-Pyroar)
  'flame-body': 'Cuerpo Llama',
  'flare-boost': 'Ímpetu Ardiente',
  'flash-fire': 'Absorbe Fuego',
  'flower-gift': 'Don Floral',
  'flower-veil': 'Velo Flor',
  'fluffy': 'Peluche',
  'forecast': 'Predicción',
  'forewarn': 'Alerta',
  'friend-guard': 'Compasión',
  'frisk': 'Cacheo',
  'full-metal-body': 'Guardia Metálica',
  'fur-coat': 'Pelaje Recio',
  // G
  'gale-wings': 'Alas Vendaval',
  'gluttony': 'Gula',
  'good-as-gold': 'Cuerpo de Oro',
  'gooey': 'Baba',
  'gorilla-tactics': 'Monos de Guerra',
  'grass-pelt': 'Manto Frondoso',
  'grassy-surge': 'Herbogénesis',
  'greed': 'Codicia',
  'grim-neigh': 'Relincho Negro',
  'guard-dog': 'Perro Guardián',
  'gulp-missile': 'Traga misil',
  'guts': 'Agallas',
  // H
  'hadron-engine': 'Motor Hadrónico',
  'harvest': 'Cosecha',
  'healer': 'Alma Cura',
  'heatproof': 'Ignífugo',
  'heavy-metal': 'Metalcromo',
  'honey-gather': 'Recogemiel',
  'huge-power': 'Potencia',
  'hunger-switch': 'Mutable',
  'hustle': 'Entusiasmo',
  'hydration': 'Hidratación',
  'hyper-cutter': 'Corte Fuerte',
  // I
  'ice-body': 'Gélido',
  'ice-face': 'Cara de Hielo',
  'ice-scales': 'Escamas de Hielo',
  'illuminate': 'Iluminación',
  'illusion': 'Ilusión',
  'immunity': 'Inmunidad',
  'imposter': 'Impostor',
  'infiltrator': 'Allanamiento',
  'innards-out': 'Revés',
  'inner-focus': 'Foco Interno',
  'insomnia': 'Insomnio',
  'intimidate': 'Intimidación',
  'intrepid-sword': 'Espada Recia',
  'iron-barbs': 'Punta Acero',
  'iron-fist': 'Puño Férreo',
  // J-K-L
  'justified': 'Justiciero',
  'keen-eye': 'Vista Lince',
  'klutz': 'Zopenco',
  'leaf-guard': 'Defensa Hoja',
  'levitate': 'Levitación',
  'libero': 'Líbero',
  'light-metal': 'Metalligero',
  'lightning-rod': 'Pararrayos',
  'limber': 'Flexibilidad',
  'liquid-ooze': 'Viscosecreción',
  'liquid-voice': 'Voz Fluida',
  'long-reach': 'Remoto',
  'lotus-dance': 'Danza Loto',
  // M
  'magic-bounce': 'Espejo Mágico',
  'magic-guard': 'Muro Mágico',
  'magician': 'Prestidigitador',
  'magma-armor': 'Escudo Magma',
  'magnet-pull': 'Imán',
  'malleable': 'Maleable',
  'mega-sol': 'Megasol', // Pokémon Champions (Mega-Meganium)
  'mew-force': 'Fuerza Mew',
  'mercy': 'Piedad',
  'merciless': 'Saña',
  'mimicry': 'Mimetismo',
  'minds-eye': 'Ojo Mental',
  'minus': 'Menos',
  'mirror-armor': 'Coraza Reflejo',
  'misty-surge': 'Nebulogénesis',
  'mold-breaker': 'Rompemoldes',
  'moody': 'Veleta',
  'motor-drive': 'Electromotor',
  'moxie': 'Autoestima',
  'multiscale': 'Compensación',
  'multitype': 'Multitipo',
  'mummy': 'Momia',
  'mycelium-might': 'Poder Micológico',
  // N
  'natural-cure': 'Cura Natural',
  'neuroforce': 'Fuerza Cerebral',
  'neutralizing-gas': 'Gas Reactivo',
  'no-guard': 'Indefenso',
  'normalize': 'Normalidad',
  // O
  'oblivious': 'Despiste',
  'opportunist': 'Oportunista',
  'orichalcum-pulse': 'Latido Oricalco',
  'overcoat': 'Funda',
  'overgrow': 'Espesura',
  'own-tempo': 'Ritmo Propio',
  // P
  'parental-bond': 'Amor Filial',
  'pastel-veil': 'Velo Pastel',
  'perish-body': 'Cuerpo Mortal',
  'pickpocket': 'Hurto',
  'pickup': 'Recogida',
  'piercing-drill': 'Taladro Perforante', // Pokémon Champions (Mega-Excadrill)
  'pixilate': 'Piel Hada',
  'plus': 'Más',
  'poison-heal': 'Antídoto',
  'poison-point': 'Punto Tóxico',
  'poison-puppeteer': 'Titiritero',
  'poison-touch': 'Toque Tóxico',
  'power-construct': 'Agrupamiento',
  'power-of-alchemy': 'Reacción Química',
  'power-spot': 'Fuente Energía',
  'prankster': 'Bromista',
  'pressure': 'Presión',
  'primordial-sea': 'Mar del Albor',
  'prism-armor': 'Armadura Prisma',
  'propeller-tail': 'Hélice',
  'protean': 'Mutatipo',
  'protosynthesis': 'Paleosíntesis',
  'psychic-surge': 'Psicogénesis',
  'punk-rock': 'Punk Rock',
  'pure-power': 'Energía Pura',
  'purifying-salt': 'Sal Purificadora',
  // Q-R
  'quark-drive': 'Carga Cuark',
  'queenly-majesty': 'Regia Presencia',
  'quick-draw': 'Desenfundado',
  'quick-feet': 'Pies Rápidos',
  'rain-dish': 'Cura Lluvia',
  'rattled': 'Cobardía',
  'receiver': 'Receptor',
  'reckless': 'Audaz',
  'refrigerate': 'Piel Helada',
  'regenerator': 'Regeneración',
  'resolute': 'Resuelto',
  'rivalry': 'Rivalidad',
  'rks-system': 'Sistema Alfa',
  'rock-head': 'Cabeza Roca',
  'rocky-payload': 'Carga Rocosa',
  'rough-skin': 'Piel Tosca',
  'run-away': 'Fuga',
  // S
  'sand-force': 'Poder Arena',
  'sand-rush': 'Ímpetu Arena',
  'sand-spit': 'Expulsarena',
  'sand-stream': 'Chorro Arena',
  'sand-veil': 'Velo Arena',
  'sap-sipper': 'Herbívoro',
  'schooling': 'Banco',
  'scovillain-drought': 'Sequía Scovillain',
  'scrappy': 'Intrépido',
  'screen-cleaner': 'Antibarrera',
  'seeds-of-ruin': 'Semilla Debilidad',
  'serene-grace': 'Dicha',
  'shadow-shield': 'Guardia Espectro',
  'shadow-tag': 'Sombratrampa',
  'sharpness': 'Agudeza',
  'shed-skin': 'Mudar',
  'sheer-force': 'Potencia Bruta',
  'shell-armor': 'Caparazón',
  'shield-dust': 'Polvo Escudo',
  'shields-down': 'Escudo Limitado',
  'shiner': 'Brillante',
  'simple': 'Simple',
  'skill-link': 'Encadenado',
  'slow-start': 'Inicio Lento',
  'slush-rush': 'Quitanieves',
  'sniper': 'Francotirador',
  'snow-cloak': 'Manto Níveo',
  'snow-warning': 'Nevada',
  'solar-power': 'Poder Solar',
  'solid-rock': 'Roca Sólida',
  'soul-heart': 'Coránima',
  'soundproof': 'Insonorizar',
  'speed-boost': 'Impulso',
  'spicy-spray': 'Rociada Picante', // Pokémon Champions (Mega-Scovillain)
  'stakeout': 'Vigilante',
  'stall': 'Rezagado',
  'stalwart': 'Acérrimo',
  'stamina': 'Firmeza',
  'stance-change': 'Cambio Táctica',
  'static': 'Electricidad Estática',
  'steadfast': 'Impasible',
  'steam-engine': 'Combustible',
  'steel-worker': 'Acero Templado',
  'steely-spirit': 'Alma Acerada',
  'stench': 'Hedor',
  'sticky-hold': 'Viscosidad',
  'storm-drain': 'Colector',
  'strong-jaw': 'Mandíbula Fuerte',
  'sturdy': 'Robustez',
  'suction-cups': 'Ventosas',
  'super-luck': 'Afortunado',
  'supersweet-syrup': 'Miel Dulce',
  'supreme-overlord': 'General Supremo',
  'surge-surfer': 'Cola Surf',
  'swarm': 'Enjambre',
  'sweet-veil': 'Velo Dulce',
  'swift-swim': 'Nado Rápido',
  'symbiosis': 'Simbiosis',
  'synchronize': 'Sincronía',
  // T
  'tablets-of-ruin': 'Tablilla Debilidad',
  'tangled-feet': 'Tanteo',
  'tangling-hair': 'Rizos Rebeldes',
  'technician': 'Experto',
  'telepathy': 'Telepatía',
  'tera-shell': 'Caparazón Tera',
  'teraform-zero': 'Teraformación Cero',
  'tera-shift': 'Cambio Tera',
  'teravolt': 'Terravoltaje',
  'thermal-exchange': 'Termoconversión',
  'thick-fat': 'Sebo',
  'thirteen-souls': 'Trece Almas',
  'thick-skin': 'Piel Gruesa',
  'thought-shield': 'Escudo Mental',
  'toxic-debris': 'Residuos Tóxicos',
  'toxic-boost': 'Ímpetu Tóxico',
  'toxic-chain': 'Cadena Tóxica',
  'tough-claws': 'Garra Dura',
  'trace': 'Rastro',
  'transistor': 'Transistor',
  'triage': 'Triaje',
  'truant': 'Ausente',
  'turboblaze': 'Turbollama',
  // U-V
  'unaware': 'Ignorante',
  'unburden': 'Liviano',
  'unnerve': 'Nerviosismo',
  'unseen-fist': 'Puño Invisible',
  'vessel-of-ruin': 'Caldero Debilidad',
  'victory-star': 'Tinovictoria',
  'vital-spirit': 'Espíritu Vital',
  'volt-absorb': 'Absorbe Electricidad',
  // W-X-Y-Z
  'water-absorb': 'Absorbe Agua',
  'water-bubble': 'Pompa',
  'water-compaction': 'Hidrorrefuerzo',
  'water-veil': 'Velo Agua',
  'weak-armor': 'Armadura Frágil',
  'well-baked-body': 'Cuerpo Horneado',
  'white-smoke': 'Humo Blanco',
  'wimp-out': 'Huida',
  'wind-power': 'Energía Eólica',
  'wind-rider': 'Surcavientos',
  'wonder-guard': 'Superguarda',
  'wonder-skin': 'Piel Milagro',
  'zen-mode': 'Modo Daruma',
  'zero-to-hero': 'Heroísmo'
};
